import React from "react";
import { clsx } from "clsx";
import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui/input";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
}
export const FormInput: React.FC<Props> = ({ name, ...props }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const error = errors[name]?.message as string;

  const className = clsx(props.className, {
    "border-red-500 mb-1": !!error,
  });

  return (
    <>
      <Input {...register(name)} {...props} className={className} />
      {error && <p className="mb-2 text-xs text-red-500">{error}</p>}
    </>
  );
};
